import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c83e1f16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "blog-card" }
const _hoisted_3 = { class: "meta" }
const _hoisted_4 = {
  class: "photo card-header",
  style: {"background-color":"#072878"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, /*#__PURE__*/_toDisplayString('Capitulos'), -1))
const _hoisted_6 = { class: "description" }
const _hoisted_7 = { class: "genero-color" }
const _hoisted_8 = { class: "read-more" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Ver")

import { useRouter } from 'vue-router'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/es-mx'
import { Story } from '@/data/models/Story'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoryComponent',
  props: {
    stories: null
  },
  setup(__props: any) {

const props = __props as {
	stories: Array<Story>
}

dayjs.extend(relativeTime)
dayjs.locale('es-mx')



const router = useRouter()

function showChapters(item: Story){
  router.push(`/storie/${item.id}/chapters`)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.stories, (s, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-lg-4 col-md-6 mb-5",
        key: i
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("h1", null, _toDisplayString(s.numberChapters), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h1", null, _toDisplayString(s.title), 1),
            _createElementVNode("h5", _hoisted_7, _toDisplayString(s.genre), 1),
            _createElementVNode("h2", null, _toDisplayString(`Creado: ${_unref(dayjs)(s.created * 1000).fromNow()}`), 1),
            _createElementVNode("p", null, _toDisplayString(`Descripción: ${s.description}`), 1),
            _createElementVNode("p", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: "#",
                onClick: ($event: any) => (showChapters(s))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})